export enum internalColumnType {
  selectRow = 'select-row',
  expandRow = 'expand-row',
  menu = 'menu'
}

export const internalColumnTypes: string[] = [
  internalColumnType.expandRow,
  internalColumnType.menu,
  internalColumnType.selectRow
];
